import { render, staticRenderFns } from "./CreateUSSDCodeDialog.vue?vue&type=template&id=39376ade&scoped=true&"
import script from "./CreateUSSDCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateUSSDCodeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39376ade",
  null
  
)

export default component.exports